/* eslint-disable class-methods-use-this */
import { History } from 'history';
import { Dispatch } from 'redux';
import { TcsmEpiApiState } from '../../../../../../root/tcsm-model';
import { GpsType } from '../../../../../../global/components/layout/layout-models';
import { DBPlanAdoptionContentModel, DbPlanSubmitRequest } from '../models/plan-adoption-form-models';
import { DbPlanAdoptionWizard } from './db-plan-adoption-wizard';
import { getSummaryPlan, postDbPlan, validateDbPlan } from '../../../../../../global/ducks/benadmin-api';
import { PensionPlanTypes } from '../../plan-history/plan-history-models';
import { dispatchSetPlanSummary } from '../../institution-slice';
import { DocuSignRequest, DocuSignResult } from '../../../docusign/models/docusign-models';
import { apiErrorClear } from '../../../../../../global/ducks/base-api';
import { getFormattedDate } from '../../../../../../global/helpers/date-helpers';
import { Institution } from '../../../../../../global/models/institution-model';
import { formatDate, formatDateMonthNumber } from '../../../../../../global/helpers/form-data-helper';

export class LayDbPlanAdoptionWizard extends DbPlanAdoptionWizard {

	readonly onSuccessUrl: string;

	private currentRequest: DbPlanSubmitRequest;

	constructor(dispatch: Dispatch<any>, history: History<unknown>, epiContent: TcsmEpiApiState, onSuccessUrl: string) {
		super(dispatch, history, epiContent);
		this.onSubmit = this.layDbSubmit;
		this.onSuccessUrl = onSuccessUrl;
	}


	private onValidateSuccess() {
		this.currentRequest.toggleDocusign(true);
	}



	onSubmitSuccess(clientNumber: string, envelopeId: string) {
		this.dispatch(getSummaryPlan(clientNumber, dispatchSetPlanSummary(this.dispatch)));
		this.dispatch(apiErrorClear());
		this.history?.push({
			pathname: this.onSuccessUrl,
			search: `?formType=${PensionPlanTypes.LayDb}`,
			state: {
				request: {
					values: { envelopeId },
				},
			},
		});
	}

	getCustomFields(institution: Institution, indenmnified?: boolean) {
		const fields = [
			{
				tabLabel: 'client_id',
				value: institution.org_client_nbr,
			}
			,
			{
				tabLabel: 'adoption_date',
				value: getFormattedDate(this.currentRequest?.values?.adoption_date),
			},
			{
				tabLabel: 'institution_name',
				value: institution.organization_name,
			},
			{
				tabLabel: 'address_1',
				value: `${institution.physical_address_1} ${institution.physical_address_2} ${institution.physical_address_3}`,
			},
			{
				tabLabel: 'address_2',
				value: `${institution.physical_city} ${institution.physical_state} ${institution.physical_country} ${institution.physical_postal_code}`,
			},
		];

		if (indenmnified)
			fields.push({
				tabLabel: 'indemnified',
				value: 'Completed',
			});
		return fields;
	}

	getDocusignOption(docuSignRequest: DocuSignRequest, toggleDocusign: any, institution: Institution, indenmnified: boolean) {
		const customTextTabs = this.getCustomFields(institution, indenmnified);
		return {
			request: {
				...docuSignRequest,
				tabs: { textTabs: customTextTabs },
			},
			finishText: this.epiContent?.institutionSettingsState?.epiContent.layDbDocuSignFinishText,
			rejectText: this.epiContent?.institutionSettingsState?.epiContent.docuSignRejectText,
			onDecline: () => {
				toggleDocusign(false);
			},
			onSigningComplete: (result: DocuSignResult) => {
				const payload = this.createSubmitModel(this.currentRequest.values, result?.envelopeId);
				this.dispatch(postDbPlan(this.currentRequest?.clientId, payload, () => this.onSubmitSuccess(this.currentRequest?.clientId, result?.envelopeId)));
			},
		};
	}

	getIndemnifyDocusignOption(docuSignRequest: DocuSignRequest, toggleDocusign: any, onComplete: any, institution: Institution) {
		const institutionAddress = `${institution?.physical_address_1}${institution?.physical_address_2}${institution?.physical_address_3}, ${institution?.physical_city}, ${institution?.physical_state} ${institution?.physical_postal_code}`;

		const customTextTabs = [
			{
				tabLabel: 'organization_name',
				value: institution.organization_name,
			},
			{
				tabLabel: 'organization_address',
				value: institutionAddress,
			},
		];
		return {
			request: {
				...docuSignRequest,
				tabs: { textTabs: customTextTabs },
			},
			finishText: this.epiContent?.institutionSettingsState?.epiContent.indemnifyLayDbDocuSignFinishText,
			rejectText: this.epiContent?.institutionSettingsState?.epiContent.indemnifyLayDbDocuSignRejectText,
			onDecline: () => {
				toggleDocusign(false);
			},
			onSigningComplete: () => {
				onComplete();
			},
		};
	}

	getFormContentModel(): DBPlanAdoptionContentModel {
		return {
			pageTitle: this.epiContent?.institutionSettingsState?.epiContent?.adoptLayDBTitle,
			PageDescription: this.epiContent?.institutionSettingsState?.epiContent?.adoptLayDBDescription,
			planAdoptionDetailTitle: this.epiContent?.institutionSettingsState?.epiContent?.adoptLayDBDetailsTitle,
			adoptingInstitutionLabel: this.epiContent?.institutionSettingsState?.epiContent?.adoptLayDBAdoptionInstitutionTitle,
			clientIdLabel: this.epiContent?.institutionSettingsState?.epiContent?.clientIdLabel,
			adoptionDateLabel: this.epiContent?.institutionSettingsState?.epiContent?.planAdoptionDateLabel,
			signHereLabel: this.epiContent?.institutionSettingsState?.epiContent?.adoptLayDBSignLabel,
			signHereTooltip: this.epiContent?.institutionSettingsState?.epiContent?.adoptLayDBSignTooltip,
			signHereDescription: this.epiContent?.institutionSettingsState?.epiContent?.adoptLayDBSignHelper,
			gpsType: GpsType.LayDbAdoption,
			indemnifyWarningTitleDc: this.epiContent?.institutionSettingsState?.epiContent?.layDbIndemnifyWarningTitleDc,
			indemnifyWarningTitleRsvp: this.epiContent?.institutionSettingsState?.epiContent?.layDbIndemnifyWarningTitleRsvp,
			indemnifyWarningRsvpMessage: this.epiContent?.institutionSettingsState?.epiContent?.layDbIndemnifyRsvpWarningMessage,
			indemnifyWarningMessage: this.epiContent?.institutionSettingsState?.epiContent?.layDbIndemnifyWarningMessage,
			indemnifyButtonText: this.epiContent?.institutionSettingsState?.epiContent?.indemnifyButtonText,
			indemnifyButtonHelper: this.epiContent?.institutionSettingsState?.epiContent?.indemnifyButtonHelper,
			indemnifySuccessMessage: this.epiContent?.institutionSettingsState?.epiContent?.layDbIndemnifySuccessMessage,
			complyEpiscopalChurchLayPensionSystemQuestion: this.epiContent?.institutionSettingsState?.epiContent?.adoptRSVPComplyEpiscopalChurchLayPensionSystemQuestion,
		};
	}

	layDbSubmit(request: DbPlanSubmitRequest) {
		const payload = this.createSubmitModel(request?.values);
		this.currentRequest = request;
		this.dispatch(validateDbPlan(
			request?.clientId,
			payload,
			() => this.onValidateSuccess(),
		));
	}

	getAdoptionDateOptions(): { text: string, value: string }[] {
		const currentDate = new Date();
		const options: { text: string, value: string }[] = [];

		// Add the current next 3 day of the month to the list.
		const currentDay = currentDate.getDate();
		const dateDelta = (currentDay === 1) ? 0 : 1;

		for (let i = 0; i < 3; i += 1) {
			const periodDate = new Date();
			periodDate.setMonth(currentDate.getMonth() + dateDelta + i);
			periodDate.setDate(1);
			options.push({
				text: formatDateMonthNumber(periodDate),
				value: formatDate(periodDate, false),
			});
		}

		return options;
	}

}